import React, { Component } from 'react';

// Call a callback when mounting or unmounting

const withMountCallback = (mountFn, unmountFn) => BaseComponent => {
  class MountCallback extends Component {
    componentDidMount() {
      this.mountData = mountFn && mountFn(this.props);
    }

    componentWillUnmount() {
      unmountFn && unmountFn(this.props, this.mountData);
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  }

  return MountCallback;
};

export default withMountCallback;
